// src/components/CreateJobCard.jsx
import React, { useState, useEffect } from 'react';
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import env from "react-dotenv";

const CreateJobCard = () => {
  const { id } = useParams(); // Get plan ID from the route
  const [productName, setProductName] = useState('');
  const [quantity, setQuantity] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductionPlan = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/production-plan/${id}`);
        const data = await response.json();
        setProductName(data.product_name); // Set product name for the plan
      } catch (error) {
        console.error('Error fetching production plan:', error);
      }
    };

    fetchProductionPlan();
  }, [id]);

  const handleSave = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/job-card`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plan_id: id, product_name: productName, quantity }),
      });
      // alert('Job Card created successfully!');
      navigate(`/view-job-card/${id}`)
      // navigate('/production-plan'); // Redirect back to ProductionPlan.jsx
    } catch (error) {
      console.error('Error creating job card:', error);
    }
  };

  return (
    <Drawer anchor="right" open={true} onClose={() => navigate('/production-plan')}>
      <Box width={400} padding={3}>
        <Typography variant="h5" align="center" gutterBottom>
          Create Job Card
        </Typography>
        <Divider style={{ marginBottom: '20px' }} />
        <TextField
          label="Product Name"
          variant="outlined"
          fullWidth
          value={productName}
          disabled
          style={{ marginBottom: '20px' }}
        />
        <TextField
          label="Enter Quantity"
          variant="outlined"
          fullWidth
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          style={{ marginBottom: '20px' }}
        />
        <Box display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate('/production-plan')}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default CreateJobCard;
